/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

export const VOICE_MESSAGE_HOLD_TOOLTIP_DURATION_MS = 2000;
export const VOICE_MESSAGE_MIN_SEND_DURATION_MS = 500;
export const VOICE_MESSAGE_RECORDING_TICK_MS = 120;
export const VOICE_MESSAGE_WAVEFORM_BAR_COUNT = 24;
export const VOICE_MESSAGE_WAVEFORM_UPDATE_INTERVAL_MS = 70;
export const VOICE_MESSAGE_LOCK_DRAG_MIN_VERTICAL_DELTA_PX = 52;
export const VOICE_MESSAGE_LOCK_DRAG_MAX_HORIZONTAL_DELTA_PX = 96;
